import { LOCALE_STORAGE_KEY } from "constants/i18n";
import { type SupportedLocale } from "types/i18n/SupportedLocaleEnum";

/**
 * Reads the visitor's stored language choice.
 *
 * @returns The raw stored value, or null when nothing is stored or storage is unavailable.
 */
export function readStoredLocale(): string | null {
  try {
    return window.localStorage.getItem(LOCALE_STORAGE_KEY);
  } catch (error) {
    // Private mode and blocked site data throw here; the page still renders in the detected language.
    console.warn("[i18n] Could not read the stored language choice.", { storageKey: LOCALE_STORAGE_KEY, error: error });
    return null;
  }
}

/**
 * Stores a language as the visitor's explicit choice, so it wins on later visits.
 *
 * @param params.locale - The chosen locale.
 */
export function writeStoredLocale({ locale }: { locale: SupportedLocale }): void {
  try {
    window.localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch (error) {
    // Unwritable storage only costs persistence; the switch itself still applies to this session.
    console.warn("[i18n] Could not store the language choice.", {
      storageKey: LOCALE_STORAGE_KEY,
      locale: locale,
      error: error,
    });
  }
}
